/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesortnewest3Inputs */

const en_ticketpagesortnewest3 = /** @type {(inputs: Ticketpagesortnewest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest first`)
};

const de_ticketpagesortnewest3 = /** @type {(inputs: Ticketpagesortnewest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste zuerst`)
};

/**
* | output |
* | --- |
* | "Newest first" |
*
* @param {Ticketpagesortnewest3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesortnewest3 = /** @type {((inputs?: Ticketpagesortnewest3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesortnewest3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesortnewest3(inputs)
	return de_ticketpagesortnewest3(inputs)
});
export { ticketpagesortnewest3 as "ticketPageSortNewest" }